//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';
import styled, { useTheme } from 'styled-components';

import { useSetCurrentUserSettingsMutation } from '@account-settings/accountSettingsMutations';
import ActionButton from '@components/atoms/action-button/ActionButton';
import IUserSettings from '@models/IUserSettings';
import { VibeIntroduction } from '@welcome-page/components/onboarding/vibe/VibeIntroduction';
import { ONBOARDING_TRACKING_ID } from '@welcome-page/constants/OnboardingConstants';

interface Props {
  settings?: IUserSettings;
}

// TODO: PD-257587 - remove this component
export const VibeAnnouncement = ({ settings }: Props) => {
  const theme = useTheme();

  const setUserSettings = useSetCurrentUserSettingsMutation();

  if (settings?.hasViewedVibeOnboarding) {
    return null;
  }

  return (
    <RootContainer>
      <HeaderContainer>
        <ActionButton
          aria-label='Hide Vibe Announcement'
          iconColor={theme.colors.white}
          iconName='close'
          onClick={() =>
            setUserSettings.mutate({ hasViewedVibeOnboarding: true })
          }
          size='large'
          trackingId={ONBOARDING_TRACKING_ID.VIBE_CLOSE_BUTTON}
        />
      </HeaderContainer>
      <VibeIntroduction />
    </RootContainer>
  );
};

const RootContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  padding-top: 155px;
  padding-bottom: 155px;
  padding-right: 146px;
  padding-left: 146px;
  gap: 50px;
  background: linear-gradient(
    133deg,
    #c142e0 1.67%,
    #455ef0 40.38%,
    #50cdf2 87.39%
  );
  align-items: center;
`;

const HeaderContainer = styled.div(
  ({ theme }) => `
  position: absolute;
  top: ${theme.spacings[3]};
  right: ${theme.spacings[3]};
`,
);
